// pages/invoices/NewInvoicePage.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Breadcrumbs, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import InvoiceForm from '../../components/invoices/InvoiceForm';

const NewInvoicePage: React.FC = () => {
  const navigate = useNavigate();

  const handleSubmit = (invoice: any) => {
    // Redirect to invoice list or specific invoice view
    navigate('/admin/invoices');
  };

  const handleCancel = () => {
    navigate('/admin/invoices');
  };

  return (
    <Container maxWidth="xl">
      <Breadcrumbs aria-label="breadcrumb" sx={{ my: 2 }}>
        <MuiLink component={Link} to="/" color="inherit">
          Home
        </MuiLink>
        <MuiLink component={Link} to="/admin/invoices" color="inherit">
          Invoices
        </MuiLink>
        <Typography color="text.primary">New Invoice</Typography>
      </Breadcrumbs>

      <InvoiceForm onSubmit={handleSubmit} onCancel={handleCancel} />
    </Container>
  );
};

export default NewInvoicePage;
